<div class="tab-container">
  <ul class="nav nav-tabs" role="tablist">
    <li class="nav-item" id="alert-tab-details">
      <a id="alert-tab-details-item" type="button" class="nav-link" role="tab" (click)="onTabChange(1)" [ngClass]="{'active': activeTab === 1}">{{_appService.CoreCommonLiterals.Alarms}}</a>
    </li> 
    <li class="nav-item" id="alert-tab-notifications">
      <a id="alert-tab-notifications-item" type="button" class="nav-link" role="tab" (click)="onTabChange(2)" [ngClass]="{'active': activeTab === 2}">Consumo</a>
    </li>
  </ul>
  <div class="tab-content">
    <div class="tab-pane fade mt-3" [ngClass]="{'active show': activeTab === 1}">
      <app-alarms-map></app-alarms-map>
    </div>
    <div class="tab-pane fade mt-3" [ngClass]="{'active show': activeTab === 2}">
      <app-custom-map *ngIf="showCustomMap"></app-custom-map>
    </div>
  </div>
</div>
